import HttpHandler from 'app/reusable/HttpHandler'
import * as types from './types'

/**
 * Fetches the current user's resolved feature flags from
 * GET /api/feature-flags/ and stores them.
 *
 * On success, replaces the store's flags with the response. On failure
 * (network error, timeout, 5xx — see HttpHandler.getFeatureFlags) the
 * reducer deliberately leaves any previously-cached flags untouched: a
 * flaky/offline flags fetch must never block or degrade the rest of the
 * app, and the next login attempt calls this again (see
 * ducks/auth/actions.js#getUserInfo, which dispatches this after a
 * successful login).
 */
export const fetchFeatureFlags = (userId) => (dispatch) => {
  return HttpHandler.getFeatureFlags()
    .then(({ data }) => {
      dispatch({
        type: types.FETCH_FEATURE_FLAGS_SUCCESS,
        payload: { userId, flags: data || {}, timestamp: Date.now() },
      })
    })
    .catch((error) => {
      dispatch({
        type: types.FETCH_FEATURE_FLAGS_ERROR,
        payload: { userId, error },
      })
    })
}

/**
 * Resets the feature flags store. Dispatched once on every full page
 * load/reload (see App.jsx) so a stale cache never survives a reload —
 * the next login re-populates it via fetchFeatureFlags above.
 */
export const clearFeatureFlags = () => ({ type: types.CLEAR_FEATURE_FLAGS })
